/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getFlightTicketApi } from '../../api/flightApi';
import {
  NAVIGATION_ROUTES,
  DATE_MONTH_YEAR_VIEW_FORMAT,
} from '../../shared/constants/Constants';
import {
  formatCurrency,
  formatDate,
  formatTimeString,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import { getObjectFromLS } from '../../shared/helper-utils/localStorage';
import './FlightTicketPage.scss';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppLink from '../../shared/components/app-link/AppLink';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';

function FlightCustomerInvoicePage() {
  const navigate = useNavigate();
  const { transactionId } = useParams();
  const [hasTicket, setHasTicket] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const flightInvoiceRef = useRef(null);
  const passengerRef = useRef(null);
  const fareSummaryRef = useRef({});
  const flightSectorsRef = useRef({});
  const flightRecordRef = useRef({});
  const sectorFareTypesRef = useRef({});
  const sectorFullNameMapRef = useRef({});
  const barCodesRef = useRef({});
  const agentDetailsRef = useRef(null);
  const flightTicketRef = useRef(null);
  const passengerSSRRef = useRef([]);
  const onwardSectorRef = useRef([]);
  const onwardPaxRef = useRef([]);

  useEffect(() => {
    document.getElementsByClassName('app-header')[0].style.display = 'none';
    document.getElementsByClassName('app-footer')[0].style.display = 'none';
  }, []);

  const getFlightTicketRoute = () => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', transactionId);
    navigate(route);
  };

  const getFlightAgentInvoiceRoute = () => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', transactionId);
    navigate(route);
  };

  const setFareSummary = (data) => {
    const invoice = data.FullFlightDetails.FlightInvoice;
    let FlightApiPricingLog = {};
    if (
      invoice.UpdatedFlightApiPricingLogs &&
      invoice.UpdatedFlightApiPricingLogs !== '' &&
      invoice.UpdatedFlightApiPricingLogs.FlightApiPricingLog
    ) {
      FlightApiPricingLog =
        invoice.UpdatedFlightApiPricingLogs.FlightApiPricingLog;
    } else {
      FlightApiPricingLog = invoice.FlightApiPricingLogs.FlightApiPricingLog;
    }
    let FullBreakup = {};
    if (FlightApiPricingLog?.ResponseXml) {
      FullBreakup = FlightApiPricingLog?.ResponseXml.FullBreakup;
    }
    let kValue = 0;
    if (Object.keys(FullBreakup).length > 0) {
      kValue = FullBreakup.AdultJn + FullBreakup.AdultJn + FullBreakup.AdultJn;
      if (invoice.FlightRecord.JType !== 'OneWay') {
        kValue += kValue;
      }
    }

    const fareDetailsStr =
      invoice.FlightRecord.FareDetails.split('##').map(Number);
    const baseFare = fareDetailsStr[0];
    const additionalMarkup = invoice.AdditionalMarkup;
    const totalTaxes =
      fareDetailsStr[1] +
      fareDetailsStr[10] +
      fareDetailsStr[8] +
      fareDetailsStr[6] +
      additionalMarkup;
    const ssr = invoice.FlightRecord.SSRAmount;
    const serviceCharges = fareDetailsStr[3];
    const commmission = fareDetailsStr[5];
    const tds = fareDetailsStr[4];
    const pgCharges = invoice.FlightRecord.PgCharges;
    const insurance = invoice.FlightRecord.TravelInsuranceAmount;
    fareSummaryRef.current = {
      basefare: baseFare,
      totaltax: totalTaxes,
      addons: ssr,
      servicecharges: serviceCharges,
      Commmission: commmission,
      Tds: tds,
      kvalue: kValue,
      pgCharges,
      insurance,
    };

    const gst_number = agentDetailsRef.current.Gst_number;
    const serviceTax = fareDetailsStr[3];
    let sgst = 0;
    let cgst = 0;
    let igst = 0;
    if (gst_number && gst_number.substring(0, 2) === '24') {
      sgst = serviceTax / 2;
      cgst = serviceTax / 2;
      igst = 0;
    } else {
      sgst = 0;
      cgst = 0;
      igst = serviceTax;
    }
    fareSummaryRef.current.Sgst = sgst;
    fareSummaryRef.current.Cgst = cgst;
    fareSummaryRef.current.Igst = igst;
    const totalAmount = fareDetailsStr[11] + ssr + additionalMarkup;
    fareSummaryRef.current.totalamount = totalAmount;
  };

  const getData = async () => {
    setIsLoading(true);
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const response = await getFlightTicketApi(
      transactionId,
      userProfile.agentId,
    );
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      const { FlightInvoice, UserDetails } =
        response.ApiStatus.Result.FullFlightDetails;
      flightInvoiceRef.current = FlightInvoice;
      flightRecordRef.current = FlightInvoice.FlightRecord;
      agentDetailsRef.current = UserDetails.UserProfile;
      const { FlightTicket } = FlightInvoice.FlightTickets;
      flightTicketRef.current = Array.isArray(FlightTicket)
        ? FlightTicket
        : [FlightTicket];
      if (FlightInvoice.BarCodes) {
        barCodesRef.current = Array.isArray(FlightInvoice.BarCodes.BarCode)
          ? FlightInvoice.BarCodes.BarCode
          : [FlightInvoice.BarCodes.BarCode];
      }
      if (FlightInvoice.PassengerSSRRecords !== '') {
        const { PassengerSSRRecord } = FlightInvoice.PassengerSSRRecords;
        passengerSSRRef.current = Array.isArray(PassengerSSRRecord)
          ? PassengerSSRRecord
          : [PassengerSSRRecord];
      }
      let { SectorRecord } = flightInvoiceRef.current.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      sectorFareTypesRef.current = SectorRecord.reduce((acc, cur) => {
        if (!acc[cur]) {
          acc[`${cur.Origin} - ${cur.Destination}`] = cur.Faretype;
        }
        return acc;
      }, {});
      sectorFullNameMapRef.current = SectorRecord.reduce((acc, sector) => {
        if (acc[sector.Origin] === undefined) {
          acc[sector.Origin] =
            sector.OriginFullName === '-'
              ? sector.Origin
              : sector.OriginFullName;
        }
        if (acc[sector.Destination] === undefined) {
          acc[sector.Destination] =
            sector.DestinationFullName === '-'
              ? sector.Destination
              : sector.DestinationFullName;
        }
        return acc;
      }, {});
      flightSectorsRef.current = SectorRecord;
      onwardSectorRef.current = flightSectorsRef.current.filter(
        (sector) => sector.FlightType.toLowerCase() === 'onward',
      );
      let { PassengerRecord } = flightInvoiceRef.current.PassengerRecords;
      PassengerRecord = Array.isArray(PassengerRecord)
        ? PassengerRecord
        : [PassengerRecord];
      passengerRef.current = PassengerRecord;
      passengerRef.current.forEach((pax) => {
        const ft = flightTicketRef.current.find((x) => x.Paxid === pax.Paxid);
        const ssr = passengerSSRRef.current.find((x) => x.Paxid === pax.Paxid);
        if (ft) {
          pax.flightTicketNumber = ft.TicketNumber;
          pax.flightAirlinePnr = ft.AirlinePnr;
        }
        if (ssr) {
          if (ssr.SSRType === 'meal') {
            pax.ssrMeal = ssr.SSR;
          }
          if (ssr.SSRType === 'seat') {
            pax.ssrSeat = ssr.SSR;
          }
        }
      });
      onwardPaxRef.current = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 1,
      );
      setFareSummary(response.ApiStatus.Result);
      setHasTicket(true);
      setIsLoading(false);
    } else {
      setHasTicket(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [transactionId]);
  return (
    <section className="customer-invoice-page">
      {hasTicket && (
        <section className="print-links d-flex flex-column hide-in-print">
          <a onClick={() => window.print()}>
            <img src="/images/others/print_sidebutton.png" alt="" />
          </a>
          <a onClick={() => window.print()}>
            <img src="/images/others/email_sidebutton.png" alt="" />
          </a>
          <a href={NAVIGATION_ROUTES.FLIGHT.LANDING}>
            <img src="/images/others/home_sidebutton.png" alt="" />
          </a>
        </section>
      )}
      <AppLoading isLoading={isLoading} />
      {hasTicket !== undefined && hasTicket && (
        <section className="customer-invoice-page_container">
          <div className="d-flex gap-3 mb-3">
            <AppLink linkText="E-Ticket" onClick={getFlightTicketRoute} />
            <AppLink
              linkText="Agent invoice"
              onClick={getFlightAgentInvoiceRoute}
            />
          </div>
          <div className="address-container d-flex justify-content-between">
            <div className="d-flex flex-column">
              <h3 className="fw-bold">Invoice</h3>
              <span>To,</span>
              <input type="text" size="40" />
              <input type="text" size="40" />
              <input type="text" size="40" />
            </div>
            <div className="d-flex flex-column">
              <b className="border-bottom d-flex pb-1">Registered Office</b>
              <div
                className="d-flex flex-column fw-bold mt-2"
                style={{ color: 'blue' }}
              >
                <span>{agentDetailsRef.current.Company}</span>
                <span>{agentDetailsRef.current.Address1}</span>
                <span>
                  {agentDetailsRef.current.City},{agentDetailsRef.current.State}
                  ,{agentDetailsRef.current.PinCode}
                </span>
              </div>
              <span>
                {agentDetailsRef.current.ContactNumber}
                {' , '}
                {agentDetailsRef.current.ContactEmail}
              </span>
            </div>
          </div>
          <table className="flight-ticket-print mt-4">
            <tbody>
              <tr>
                <td>Airline PNR</td>
                <td>{flightRecordRef.current.AirlinePnr.split(',')[0]}</td>
                <td>Booking Date</td>
                <td>
                  {formatDate(
                    getNewDate(
                      flightRecordRef.current.BookingDate.split(' ')[0],
                    ),
                    DATE_MONTH_YEAR_VIEW_FORMAT,
                  )}
                </td>
                <td>Booking Id</td>
                <td>{flightRecordRef.current.Txid}</td>
                <td> Booking Status</td>
                <td>{flightRecordRef.current.BookingStatus}</td>
              </tr>
            </tbody>
          </table>
          <div>
            <table className="flight-ticket-print mt-4">
              <thead>
                <th>From-to</th>
                <th>Flight</th>
                <th>Departure Date</th>
                <th>Departure</th>
                <th>Arrival</th>
              </thead>
              <tbody>
                {flightSectorsRef.current.map((sector) => (
                  <tr key={`${sector.Origin}:${sector.Destination}`}>
                    <td>
                      {sector.OriginFullName} ( {sector.Origin} ) --&gt;{' '}
                      {sector.DestinationFullName} ( {sector.Destination} ){' '}
                    </td>
                    <td>
                      {sector.OperatedBy} {sector.Carrier} -{' '}
                      {sector.FlightNumber} ( Class - {sector.BookingClass} ){' '}
                    </td>
                    <td>
                      {formatDate(
                        getNewDate(sector.JourneyDate),
                        DATE_MONTH_YEAR_VIEW_FORMAT,
                      )}
                    </td>
                    <td>{formatTimeString(sector.DepartureTime)}</td>
                    <td>{formatTimeString(sector.ArrivalTime)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table className="flight-ticket-print mt-4">
              <thead>
                <th>Name</th>
                <th>Pax Type</th>
                <th>Flight Ticket Numbers</th>
              </thead>
              <tbody>
                {onwardPaxRef.current.map((passenger) => (
                  <tr key={`${passenger.Paxid}_${passenger.FirstName}`}>
                    <td style={{ textTransform: 'uppercase' }}>
                      {passenger.Title} {passenger.FirstName}{' '}
                      {passenger.LastName}
                    </td>
                    <td>{passenger.Type}</td>
                    <td>
                      {flightInvoiceRef.current.FlightRecord.TicketNumbers}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table className="flight-ticket-print mt-4">
              <thead>
                <th>No of pax</th>
                <th>Base Fare</th>
                <th>Taxes and Fees</th>
                <th>SSR Amount</th>
                <th>Service Tax</th>
                <th>PG Charges</th>
                <th>Insurance</th>
                <th>Total Amount</th>
              </thead>
              <tbody>
                <td>{flightInvoiceRef.current.FlightRecord.NumPax}</td>
                <td>{fareSummaryRef.current.basefare.toFixed(2)}</td>
                <td>{fareSummaryRef.current.totaltax.toFixed(2)}</td>
                <td>{fareSummaryRef.current.addons.toFixed(2)}</td>
                <td>{fareSummaryRef.current.servicecharges.toFixed(2)}</td>
                <td>{fareSummaryRef.current.pgCharges.toFixed(2)}</td>
                <td>{fareSummaryRef.current.insurance.toFixed(2)}</td>
                <td>{fareSummaryRef.current.totalamount.toFixed(2)}</td>
              </tbody>
            </table>
          </div>
          <div className="d-flex align-items-end mt-4 flex-column fw-bold border-bottom">
            <p className="mb-1">Authorised Signatory</p>
            <p>{agentDetailsRef.current.Company}</p>
          </div>
        </section>
      )}
      {hasTicket !== undefined && hasTicket === false && (
        <section className="flight-ticket-invoice_container">
          No Invoice found with {transactionId}
        </section>
      )}
    </section>
  );
}

export default FlightCustomerInvoicePage;
